const config = {
  selector: {
    count: '[data-count="wishlist-count"]',
    countHidden: '[data-count="wishlist-count-hidden"]',
    wishlistOpen: '[data-action="wishlist-open"]',
    wishlistClose: '[data-action="wishlist-close"]'
  }
}

export default config
